'use client'

import { NextIntlClientProvider } from 'next-intl';

import { createContext, Dispatch, ReactNode, useContext, useEffect, useMemo, useState } from "react";
// 언어코드 수정
import koMessages from '@/messages/ko.json';
import enMessages from '@/messages/en.json';
import msMessages from '@/messages/ms.json';
import zhMessages from '@/messages/zh.json';
import idMessages from '@/messages/id.json';

import { DefaultLangCode, langDefaultList, langTypes, sitelangs } from '@/type/lang';
import { getCookie, setCookie } from '@/util/cookie';
import { useRouter } from 'next/navigation';

export const langContext = createContext<{
    lang: string
    langList: langTypes[]
    setLangList: Dispatch<langTypes[]>
    Setlang: (lang: string) => void
    frontLang: boolean
}>({
    lang: "ko",
    langList: langDefaultList,
    setLangList: () => { },
    Setlang: () => { },
    frontLang: false
})
/**
 * 
 * 언어코드 수정/추가 시
 * "언어코드 수정" 검색하여 컴포넌트, css class 등 수정/추가 진행
 *  /messages/[언어].json 파일 수정/추가 진행
 */
export default function LangProviders({ children }: { children: ReactNode }) {
    const [lang, setlang] = useState<string>(DefaultLangCode)
    // siteContext 에서 setLangList 저장
    const [langList, setLangList] = useState<langTypes[]>([])
    const [mountLang, setMountLang] = useState<string>()
    // 언어코드 수정
    const messagesList: Record<string, any> = {
        "ko": koMessages,
        "en": enMessages,
        "ms": msMessages,
        "zh": zhMessages,
        "id": idMessages,
    }
    const messages = useMemo(()=> {
        if (!mountLang) return messagesList['en']

        return messagesList[mountLang] ?? messagesList['en']
    }, [mountLang])

    const router = useRouter();

    /** 새로고침 없이 프론트 언어 사용 할 때(언어팩 테스트용) true */
    const frontLang: boolean = false

    function Setlang(lang: string) {
        setCookie('lang', lang, { path: "/" })
        setlang(lang)
        document.documentElement.setAttribute("lang", lang);

        if(frontLang){
            setMountLang(lang)
        }else{
            if (!mountLang) {
                // 쿠키 또는 사이트 active_language 적용 후
                setMountLang(lang)
            }
        }
    }

    useEffect(() => {
        if (!mountLang) return;

        // 초기화 이후 변경 시
        if (lang != mountLang) {
            if(!frontLang){
                // lang 변경 시, 새로고침
                window.location.href = window.location.pathname;
            }
        }
    }, [lang, mountLang])

    const returnValue = {
        lang,
        Setlang,
        langList,
        setLangList,
        frontLang
    }

    return (

        <NextIntlClientProvider locale={lang} messages={messages}>
            <langContext.Provider value={returnValue} >
                {children}
            </langContext.Provider>
        </NextIntlClientProvider>
    )
}

export const uselang = () => useContext(langContext)